import { REGEX_UNICODE, REGEX_EMAIL } from "@/_helpers/constant.js";
import store from "@/plugins/store";
import i18n from "@/plugins/i18n";
import moment from "moment";

export async function _storeData(name, value) {
    try {
        await localStorage.setItem(name, value);
    } catch (error) {
        // Error saving data
        // console.log(error);
    }
}

export async function _retrieveData(name) {
    try {
        const value = await localStorage.getItem(name);
        if (value !== null) {
            // We have data!!
            return value;
        }
    } catch (error) {
        // console.log(error);
        // Error retrieving data
    }
}

export function _clearData() {
    try {
        localStorage.clear();
    } catch (error) {
        // console.log(error);
    }
}

export function _formatCurrency(amount, currency) {
    // try {
    //     // if (!/^[0-9-]*$/.test(amount)) {
    //     //     return null;
    //     // }
    //     if (parseFloat(amount) === 0) {
    //         return 0;
    //     }
    //     if (!amount) return null;
    //     amount = parseFloat(amount)
    //         .toFixed(2)
    //         .replace(/\d(?=(\d{3})+\.)/g, "$& ");
    //     return amount;
    // } catch (error) {
    //     // console.log(error);
    // }
    let locale = localStorage.getItem("systemLanguage") || "vi";
    if (currency) {
        return new Intl.NumberFormat(locale === "vi" ? "vi-VN" : "en-US", {
            style: "currency",
            currency: currency ? currency : "VND",
            currencyDisplay: "narrowSymbol"
          }).format(amount);
    } else {
        return new Intl.NumberFormat(locale === "vi" ? "vi-VN" : "en-US").format(amount);
    }
 
}

export function _formatCurrencyInput(amount) {
    try {
        // if (!/^[0-9-]*$/.test(amount)) {
        //     return null;
        // }
        if (parseFloat(amount) === 0) {
            return 0;
        }
        if (!amount) return null;
        amount = parseFloat(amount)
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$&.");
        return amount.substring(0, amount.lastIndexOf("."));
    } catch (error) {
        // console.log(error);
    }
}

export function _validateEmail(email) {
    let re = REGEX_EMAIL;
    let list = email.split("");
    if (list.filter(x => x && !REGEX_UNICODE.test(x)).length > 0) {
        return false;
    }
    return re.test(String(email).toLowerCase());
}

export function _validateForm(data, error, keys) {
    try {
        let locale = localStorage.getItem("systemLanguage") || "vi"
        let isValid = true;
        let key = keys || Object.keys(error);
        key.forEach(x => {
            if (error[x].type == "email") {
                if (data[x] && !_validateEmail(data[x])) {
                    error[x].error = true;
                    store.commit("alert/display", {
                        message: locale == "vi" ? "Vui lòng kiểm tra lại định dạng email" : "Please check your email format",
                        error: true,
                        success: false
                    });
                    error[x].message = locale == "vi" ? "Vui lòng kiểm tra lại định dạng email" : "Please check your email format";
                    isValid = false;
                    return false;
                }
            }
            if (error[x].required && !data[x] && data[x] !== 0) {
                error[x].error = true;
                store.commit("alert/display", {
                    message: locale == "vi" ? "vui lòng nhập đầy đủ thông tin cần thiết" : "Please enter all required information",
                    error: true,
                    success: false
                });
                error[x].message = "";
                isValid = false;
                return false;
            } else if (
                (error[x].minValue || error[x].minValue == 0) &&
                data[x] <= error[x].minValue
            ) {
                error[x].error = true;
                store.commit("alert/display", {
                    message: `Giá trị nhập vào phải lớn hơn ${error[x].minValue}`,
                    error: true,
                    success: false
                });
                error[x].message = `Giá trị nhập vào phải lớn hơn ${error[x].minValue}`;
                isValid = false;
            } else if (
                error[x].minLength &&
                data[x].toString().length < error[x].minLength
            ) {
                error[x].error = true;
                error[x].message =
                    error[x].text ||
                    `Giá trị nhập vào phải nhiều hơn ${error[x].minLength} kí tự`;
                isValid = false;
            } else if (
                error[x].maxLength &&
                data[x].toString().length > error[x].maxLength
            ) {
                error[x].error = true;
                error[x].message =
                    error[x].message ||
                    `Giá trị nhập vào phải ít hơn ${error[x].maxLength} kí tự`;
                isValid = false;
            } else error[x].error = false;
        });
        return { isValid, error };
    } catch (err) {
        // console.log(err);
    }
}

export function _resetErrorState(error) {
    Object.keys(error).forEach(x => {
        error[x].error = false;
    })
}

export function _formatDate(date) {
    if (!date) return null;

    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
}

export function _validateFormI18n(data, error, keys) {
    let isValid = true;
    let errorState = false;
    let successState = false;
    let messages = [];
    let key = keys || Object.keys(error);
    key.forEach(x => {
        error[x].error = false;
        // Check
        if (error[x].type === "email") {
            if (data[x] && !_validateEmail(data[x])) {
                const message = i18n.t(error[x].text || "_VALIDATE.EMAIL_FORMAT");

                messages.push(message);
                errorState = true;
                successState = false;

                error[x].error = true;
                error[x].message = message;
                isValid = false;
                return false;
            }
        }
        if (error[x].required && !data[x] && data[x] !== 0) {
            const message = i18n.t("_VALIDATE.REQUIRED");

            messages.push(message);
            errorState = true;
            successState = false;

            error[x].error = true;
            // error[x].message = message;
            isValid = false;
            return false;
        } else if (error[x].minLength && data[x] && data[x].toString().length < error[x].minLength) {
            const message = i18n.t(error[x].text || "_VALIDATE.MIN_LENGTH", { 'minLength': error[x].minLength });

            messages.push(message);
            errorState = true;
            successState = false;

            error[x].error = true;
            error[x].message = message;
            isValid = false;
            return false;
        } else if (error[x].maxLength && data[x] && data[x].toString().length > error[x].maxLength) {
            const message = i18n.t(error[x].text || "_VALIDATE.MAX_LENGTH", { 'maxLength': error[x].maxLength });

            messages.push(message);
            errorState = true;
            successState = false;

            error[x].error = true;
            error[x].message = message;
            isValid = false;
            return false;
        }
    });
    store.commit("alert/display", {
        message: messages,
        error: errorState,
        success: successState,
    });
    return { isValid, error };
}

export function _alert(res, message, isReload = true) {
    let error = true;
    let success = false;
    let warning = false;
    if (res && res.responseCode == 0) {
        error = false;
        if (res.data == 'WAITING_UPDATE') {
            warning = true;
        } else {
            success = true;
        }
        
    }
    store.commit("alert/display", {
        message: message,
        error: error,
        success: success,
        warning: warning,
        res: res,
    });
    if ((success || warning) && isReload) {
        setTimeout(function () {
            location.reload();
        }, 1000);
    }
}

export function _alertLink(res, message, link) {
    let error = true;
    let success = false;
    if (res && res.responseCode == 0) {
        error = false;
        success = true;
    }
    store.commit("alertLink/display", {
        message: message,
        error: error,
        success: success,
        res: res,
        link: link
    });
}

export function _storedUserInfo(field, data) {
    let info = JSON.parse(localStorage.getItem("currentUser"));
    let fields = field.split("/");
    if (fields.length == 2) {
        info[fields[0]][fields[1]] = data;
    }
    localStorage.setItem("currentUser", JSON.stringify(info));
}

export function _formatDateTime(value, inputFormat, outputFormat) {
    return moment(value, inputFormat).format(outputFormat);
}

export function _formatDateTimeUTCToLocal(value, inputFormat, outputFormat) {
    return moment.utc(value, inputFormat).local().format(outputFormat);
}

export function _weekList() {
    // Lấy ngày cuối tuần từ localstorage
    let hotelWeekend = JSON.parse(localStorage.getItem("hotelWeekend"));
    // console.log(hotelWeekend);
    // Chuyển từ binary sang select
    let output = parseInt(hotelWeekend, 10).toString(2);
    while (output.length < 7) {
        output = "0" + output;
    }
    let defaultWeekend = output.split('');
    var tmp = [];
    defaultWeekend.forEach(function (element, index) {
        if (element == 1) {
            if (index == 0) {
                tmp.push('MON');
            }
            if (index == 1) {
                tmp.push('TUE');
            }
            if (index == 2) {
                tmp.push('WED');
            }
            if (index == 3) {
                tmp.push('THU');
            }
            if (index == 4) {
                tmp.push('FRI');
            }
            if (index == 5) {
                tmp.push('SAT');
            }
            if (index == 6) {
                tmp.push('SUN');
            }
        }
    });

    let weekList = [{
        day: "SUN",
        isWeekend: false
    },
    {
        day: "MON",
        isWeekend: false
    },
    {
        day: "TUE",
        isWeekend: false
    },
    {
        day: "WED",
        isWeekend: false
    },
    {
        day: "THU",
        isWeekend: false
    },
    {
        day: "FRI",
        isWeekend: false
    },
    {
        day: "SAT",
        isWeekend: false
    },
        // this.$t("MONDAY").toString(),
        // this.$t("TUESDAY").toString(),
        // this.$t("WEDNESDAY").toString(),
        // this.$t("THURSDAY").toString(),
        // this.$t("FRIDAY").toString(),
        // this.$t("SATURDAY").toString(),
        // this.$t("ACTION").toString(),
    ]

    weekList.forEach(x => {
        if (tmp.includes(x.day)) {
            x.isWeekend = true;
        }
    });

    return weekList;

}

// export function _convertFromBinaryToListSelection(number) {
//   let output = parseInt(number, 10).toString(2);
//   while (output.length < 7) {
//   output = "0" + output;
//   }
//   return output.split('');
// }